"use client";

import { env } from "@/env.mjs";
import { useConsentState } from "@/lib/marketing-analytics/consent-store";
import { orgPublicOriginFor } from "@v1/backend/logic/organizations/staff_host";
import { useEffect } from "react";

/** Our own Kunden-Chat (Kanäle › Eigene Webseite). Site key is public by design. */
const OWN_CHAT_SITE_KEY = "2084e922bd83368b7e72d9ea5d9e7536";
const OWN_ORG_SLUG = "powerprozesse";
/** Root id the loader creates; removed on unmount so client navigation leaves no bubble behind. */
const LOADER_ROOT_ID = "hv-customer-chat-root";
/** Our website only: never on portal or org hosts, previews or other deployments (key lives in prod). */
const OWN_WEBSITE_HOSTS: ReadonlySet<string> = new Set(["hausverwalter.ai", "www.hausverwalter.ai"]);

/** Website runs the official embed snippet, exactly like a customer's site. Loads only after the cookie banner is answered. */
export function WebsiteCustomerChat(): null {
  const bannerAnswered = useConsentState().choices !== null;
  useEffect(() => {
    if (!bannerAnswered) return;
    if (!OWN_WEBSITE_HOSTS.has(window.location.hostname)) return;
    const appOrigin = orgPublicOriginFor(env.NEXT_PUBLIC_SITE_URL, OWN_ORG_SLUG);
    const script = document.createElement("script");
    script.src = `${appOrigin}/embed/chat.js`;
    script.async = true;
    script.dataset.siteKey = OWN_CHAT_SITE_KEY;
    script.dataset.appOrigin = appOrigin;
    script.dataset.convexSite = env.NEXT_PUBLIC_CONVEX_SITE_URL.replace(/\/$/, "");
    document.body.appendChild(script);
    return () => {
      script.remove();
      document.getElementById(LOADER_ROOT_ID)?.remove();
    };
  }, [bannerAnswered]);
  return null;
}
